export default {
  layout: {
    themeStyle: 'Theme Style',
    styles: {
      grayBlue: 'Gray Blue',
      blue: 'Blue',
      lightBlue: 'Light Blue',
      green: 'Green',
      red: 'Red',
      purple: 'Purple',
      gray: 'Gray'
    },
    welcome: 'Hello',
    station: 'jeecms main site',
    personal: 'Personal Info',
    password: 'Forget Password',
    logout: 'Logout'
  },
  global: {
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    confirm: 'Confirm',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    open: 'Open',
    enabled: 'Enabled',
    disabled: 'Disabled',
    delete: 'Delete',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    deploy: 'Deploy',
    refresh: 'Refresh',
    close: 'Close',
    closeOther: 'Close Other',
    closeAll: 'Close All',
    tip: 'Tip',
    handle: 'Handle',
    success: 'Success',
    save: 'Save',
    saveAndContinue: 'Save And Continue',
    sort: 'Sort',
    prevPage: 'Prev',
    nextPage: 'Next'
  },
  // 提示语
  message: {
    confirmDelete: 'Are you sure delete ?',
    selectLeastOne: 'At least select one below to handle.'
  },
  // 验证信息
  rule: {
    required: 'required'
  }
}
